module.exports = __webpack_public_path__ + "static/media/Cats eyes 08_SPANSKA-mixdown.f97765d5.mp3";